import { render, staticRenderFns } from "./page-wizard.vue?vue&type=template&id=186b4d3c"
import script from "./page-wizard.vue?vue&type=script&lang=js"
export * from "./page-wizard.vue?vue&type=script&lang=js"
import style0 from "./page-wizard.vue?vue&type=style&index=0&id=186b4d3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports